import { PAGES } from "@/common/consts";

export default {
	[PAGES.ANAGRAM]: {
		path: "/anagram-solver",
		label: "AnagramadorIndexPageH1",
		contentUrl: "./long-content/AnagramSolver.js",
		meta: {
			title: "AnagramSolverMetaTitle",
			description: "AnagramSolverMetaDescription",
		},
	},
	[PAGES.WORD_DESCRAMBLER]: {
		path: "/word-descrambler",
		label: "WordDescramblerH1",
		contentUrl: "./long-content/WordDescrambler.js",
		meta: {
			title: "WordDescramblerMetaTitle",
			description: "WordDescramblerMetaDescription",
		},
	},
	[PAGES.WORDBRAIN_ANSWERS]: {
		path: "/wordbrain-answers",
		label: "WordbrainAnswersH1",
		contentUrl: "./long-content/WordbrainAnswers.js",
		meta: {
			title: "WordbrainAnswersMetaTitle",
			description: "WordbrainAnswersMetaDescription",
		},
	},
	[PAGES.TEXT_TWIST]: {
		path: "/text-twist",
		label: "TextTwistH1",
		contentUrl: "./long-content/TextTwist.js",
		meta: {
			title: "TextTwistMetaTitle",
			description: "TextTwistMetaDescription",
		},
	},
	[PAGES.SCRABBLE_CHECKER]: {
		path: "/scrabble-checker",
		label: "Scrabble Checker",
		contentUrl: "./long-content/ScrabbleChecker.js",
		meta: {
			title: "ScrabbleCheckerMetaTitle",
			description: "ScrabbleCheckerMetaDescription",
		},
	},
	[PAGES.JUMBLE_SOLVER]: {
		path: "/jumble-solver",
		label: "JumbleSolverH1",
		contentUrl: "./long-content/JumbleSolver.js",
		meta: {
			title: "JumbleSolverMetaTitle",
			description: "JumbleSolverMetaDescription",
		},
	},
	[PAGES.SCRABBLE_DICT]: {
		path: "/scrabble-dictionary",
		label: "Scrabble Dictionary",
		contentUrl: "./long-content/ScrabbleDictionary.js",
		meta: {
			title: "ScrabbleDictionaryMetaTitle",
			description: "ScrabbleDictionaryMetaDescription",
		},
	},
	[PAGES.WORD_CHUMS_CHEAT]: {
		path: "/word-chums-cheat",
		label: "WordChumsCheatH1",
		contentUrl: "./long-content/WordChumsCheat.js",
		meta: {
			title: "WordChumsCheatMetaTitle",
			description: "WordChumsCheatMetaDescription",
		},
	},
	[PAGES.UNSCRAMBLE]: {
		path: "/unscramble",
		label: "UnscrambleH1",
		contentUrl: "./long-content/Unscramble.js",
		meta: {
			title: "UnscrambleMetaTitle",
			description: "UnscrambleMetaDescription",
		},
	},
	[PAGES.WORDCOOKIES]: {
		path: "/word-cookies",
		label: "WordCookiesH1",
		contentUrl: "./long-content/WordCookies.js",
		meta: {
			title: "WordCookiesMetaTitle",
			description: "WordCookiesMetaDescription",
		},
	},
	[PAGES.WORDFEUD]: {
		path: "/wordfeud-helper",
		label: "WordfeudHelperH1",
		contentUrl: "./long-content/WordfeudHelper.js",
		meta: {
			title: "WordfeudHelperMetaTitle",
			description: "WordfeudHelperMetaDescription",
		},
	},
	[PAGES.WORD_MAKER]: {
		path: "/word-maker",
		label: "WordMakerH1",
		contentUrl: "./long-content/WordMaker.js",
		meta: {
			title: "WordMakerMetaTitle",
			description: "WordMakerMetaDescription",
		},
	},
	[PAGES.WORD_UNSCRAMBLER]: {
		path: "/word-unscrambler",
		label: "WordUnscramblerH1",
		contentUrl: "./long-content/WordUnscrambler.js",
		meta: {
			title: "WordUnscramblerMetaTitle",
			description: "WordUnscramblerMetaDescription",
		},
	},
	[PAGES.WWF]: {
		path: "/words-with-friends-cheat",
		label: "WordsWithFriendsCheatH1",
		contentUrl: "./long-content/WordsWithFriends.js",
		meta: {
			title: "WordsWithFriendsCheatMetaTitle",
			description: "WordsWithFriendsCheatMetaDescription",
		},
	},
	[PAGES.LETTERS_AND_BLANK]: {
		path: "/words-with-letters-blank",
		label: "WordsWithLettersBlankH1",
		contentUrl: "./long-content/WordsWithLettersBlank.js",
		meta: {
			title: "WordsWithLettersBlankMetaTitle",
			description: "WordsWithLettersBlankMetaDescription",
		},
	},
	[PAGES.WORD_SWIPE_CHEATS]: {
		path: "/word-swipe-cheats",
		label: "WordSwipeCheatsH1",
		contentUrl: "./long-content/WordSwipeCheats.js",
		meta: {
			title: "WordSwipeCheatsMetaTitle",
			description: "WordSwipeCheatsMetaDescription",
		},
	},
	[PAGES.WORDSCAPES]: {
		path: "/wordscapes-answers",
		label: "WordscapesAnswersH1",
		contentUrl: "./long-content/WordscapesAnswers.js",
		meta: {
			title: "WordscapesAnswersMetaTitle",
			description: "WordscapesAnswersMetaDescription",
		},
	},
	[PAGES.WORD_CONNECT]: {
		path: "/word-connect-answers",
		label: "WordConnectAnswersH1",
		contentUrl: "./long-content/WordConnectAnswers.js",
		meta: {
			title: "WordConnectAnswersMetaTitle",
			description: "WordConnectAnswersMetaDescription",
		},
	},
	[PAGES.CODY_CROSS]: {
		path: "/codycross-answers",
		label: "CodycrossAnswersH1",
		contentUrl: "./long-content/CodyCrossAnswers.js",
		meta: {
			title: "CodycrossAnswersMetaTitle",
			description: "CodycrossAnswersMetaDescription",
		},
	},
	[PAGES.WORD_STORY]: {
		path: "/words-story-answers",
		label: "WordsStoryAnswersH1",
		contentUrl: "./long-content/WordsStoryAnswers.js",
		meta: {
			title: "WordsStoryAnswersMetaTitle",
			description: "WordsStoryAnswersMetaDescription",
		},
	},
};
